import React from 'react';
import classNames from 'classnames';

export const OptionError = ({
  className,
  ...props
}: React.ComponentProps<'div'>) => {
  return (
    <div
      className={classNames(
        'text-[#fa4654] text-xs mt-[-14px] mx-3 mb-2.5',
        className
      )}
      {...props}
    />
  );
};
